import {
    getParamFromUrl,
    isNegotiableOrder,
    isUserComesFromAcceptedOffer,
    isUserComesFromEmail,
} from './checkoutRedirects';

export function getCheckoutTriggerPage(referrer: string): string {
    if (isUserComesFromEmail()) {
        return 'email';
    }

    if (!referrer) {
        return 'unknown';
    }

    if (referrer.indexOf('/favorites/') !== -1) {
        return 'favorites';
    } else if (referrer.indexOf('/inbox/') !== -1) {
        return 'message center';
    } else if (referrer.indexOf('/orders/') !== -1) {
        return 'my orders';
    } else if (referrer.indexOf('/cart/') !== -1) {
        return 'cart';
    } else if (referrer.indexOf('id-') !== -1 && referrer.indexOf('checkout') === -1) {
        return 'pdp';
    } else if (referrer.indexOf('/similar-sold/') !== -1) {
        return 'similar sold items';
    }

    if (referrer.includes('1stdibs.com')) {
        return 'other';
    }

    return 'external';
}

function getCheckoutTriggerFromReferrer(): string {
    const triggerPageType = getParamFromUrl('triggerPage');
    if (triggerPageType) {
        return triggerPageType;
    }

    return getCheckoutTriggerPage(document.referrer);
}

export function getCheckoutTrigger(): string {
    const triggerType = getParamFromUrl('triggerType');

    if (triggerType) {
        return triggerType;
    }

    const triggers = [];
    const trigger = getCheckoutTriggerFromReferrer();
    if (trigger) {
        triggers.push(trigger);

        if (isNegotiableOrder()) {
            triggers.push('make offer');
        } else if (getParamFromUrl('fullPrice') === 'true') {
            triggers.push('purchase at full price');
        } else if (isUserComesFromAcceptedOffer()) {
            triggers.push('accept offer');
        } else {
            triggers.push('purchase');
        }
    }

    return triggers.join('-');
}
